// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachQuarterOfInterval as fn } from "../eachQuarterOfInterval.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachQuarterOfIntervalWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default eachQuarterOfIntervalWithOptions;
